export class ListAuditLogResponse {
    'logs';
    'nextToken';
    'totalCount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "logs",
            "baseName": "logs",
            "type": "Array<AuditLog>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAuditLogResponse.attributeTypeMap;
    }
    constructor() {
    }
}
